import { CookieCategory } from "./cookieTypes";

/**
 * Define all cookies here.
 * When the cookies are empty, a simple "no cookies" banner will show.
 * When cookies are present, the full consent modal will appear.
 */

export const cookieCategories: CookieCategory[] = [
    {
        id: 'necessary',
        name: 'Notwendig',
        description: 'Diese Cookies sind für die Grundfunktionen der Website erforderlich.',
        required: true,
        cookies: [
            // {
            //   name: 'cookie_consent',
            //   provider: 'Diese Website',
            //   purpose: 'Speichert Ihre Cookie-Einstellungen',
            //   duration: '1 Jahr'
            // }
        ]
    },
    {
        id: 'functional',
        name: 'Funktional',
        description: 'Diese Cookies ermöglichen erweiterte Funktionen wie Karten und Videos.',
        required: false,
        cookies: [
            {
              name: '_Secure-1PSIDCC',
              provider: 'Google LLC',
              purpose: 'Einbettung von Karten',
              duration: 'Session'
            },
            {
              name: '_Secure-3PSIDCC',
              provider: 'Google LLC',
              purpose: 'Einbettung von Karten',
              duration: 'Session'
            },
            {
              name: '_Secure-STRP',
              provider: 'Google LLC',
              purpose: 'Einbettung von Karten',
              duration: 'Session'
            },
            {
              name: 'SIDCC',
              provider: 'Google LLC',
              purpose: 'Einbettung von Karten',
              duration: '24 Stunden'
            },
        ]
    },
    {
        id: 'analytics',
        name: 'Analyse',
        description: 'Diese Cookies helfen uns zu verstehen, wie Besucher mit der Website interagieren.',
        required: false,
        cookies: []
    },
    {
        id: 'marketing',
        name: 'Marketing',
        description: 'Diese Cookies werden verwendet, um Ihnen relevante Werbung anzuzeigen.',
        required: false,
        cookies: []
    }
];